import { render, staticRenderFns } from "./DirectorsMap.vue?vue&type=template&id=aa209836&scoped=true&"
import script from "./DirectorsMap.vue?vue&type=script&lang=js&"
export * from "./DirectorsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa209836",
  null
  
)

export default component.exports